<h2 mat-dialog-title>Filtros avançados</h2>
<h3 mat-dialog-subtitle>
  Informe quantas horas após o horário de atendimento (data/hora prevista) um relatório passa a ser considerado
  atrasado.
  Exemplo: com 48 horas, só aparecem (e são exportados) relatórios que estão 48h ou mais depois do horário de
  atendimento.
</h3>

<mat-dialog-content class="filters-grid">
  <div class="full-width-field" style="width: 100%;">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Atraso mínimo (horas)</mat-label>
      <input matInput type="number" inputmode="numeric" step="1" min="0" max="1000" placeholder="Ex.: 72"
        style="width: 100%;" [formControl]="filtersForm.controls.minDelay" />
      <mat-hint>Horas contadas a partir do horário de atendimento</mat-hint>
      <mat-error *ngIf="filtersForm.controls.minDelay.hasError('required')">Obrigatório</mat-error>
      <mat-error *ngIf="filtersForm.controls.minDelay.hasError('min')">Não pode ser negativo</mat-error>
      <mat-error *ngIf="filtersForm.controls.minDelay.hasError('max')">Máximo permitido: 1000 horas</mat-error>
      <mat-error *ngIf="filtersForm.controls.minDelay.hasError('pattern')">Somente números inteiros</mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Fechar</button>
  <button mat-flat-button color="primary" type="button" (click)="apply()" [disabled]="filtersForm.invalid">
    Aplicar
  </button>
</mat-dialog-actions>